import React from 'react'

import { Box } from '@domain-group/suit-theme'

interface ItemsProps {
  children: React.ReactNode,
}

const Items = (props: ItemsProps) => {
  const { children } = props

  return (
    <Box flexDirection="column">
      {children}
    </Box>
  )
}

export default Items
